import { useGLTF } from '@react-three/drei';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import modelsPos from '/data/modelsPos.json';


export default function Bancs() {
    const modelFile = { path: './models/banc.glb', nodeName: 'banc' };
    const model = useGLTF(modelFile.path);
    const location = useLocation();
    const groupRefs = useRef([]);

    useEffect(() => {
        groupRefs.current.forEach((group, index) => {
            if (group) {
                if (location.pathname === '/about') {
                    gsap.to(group.position, {
                        y: 0,
                        duration: 3.5,
                        delay: 2 + index * 0.25,
                        ease: 'power2.out',
                    });
                } else if (location.pathname === '/') {
                    gsap.set(group.position, { y: -5 });
                } else {
                    gsap.set(group.position, { y: 0 });
                }
            }
        });
    }, [location.pathname]);

    return (
        <>
            {modelsPos.bancs
                .sort((a, b) => a.index - b.index) 
                .map((banc, index) => (
                    <group
                        key={banc.index}
                        ref={(el) => (groupRefs.current[index] = el)}
                        position={[banc.x, banc.y - 5, banc.z]} 
                        rotation={[
                            (banc.rx * Math.PI) / 180, 
                            (banc.ry * Math.PI) / 180, 
                            (banc.rz * Math.PI) / 180
                        ]}
                    >
                        <mesh
                            geometry={model.nodes[modelFile.nodeName]?.geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    </group>
                ))}
        </>
    );
}